// Decline re-offer (2026-10-13, Storm 12:27 "re-offer to another agetn at once";
// 14:01 option (a)). Called right after Streams' contact.reject() succeeds on a
// TASK. Asks the server (knktr-transfer-prepare, action "decline-reoffer") to
// restrict the task to the other agents for ~2 min and to dismiss it from this
// agent. If the server cannot dismiss it (error, timeout, not configured), the
// browser clears it itself, so a declined task never holds the agent's slots
// (it used to block inbound calls until the sweeper cleared it ~2 min later).
// Never throws.
export async function declineAndReoffer({ contact, agentArn, url, getHeaders, fetchImpl = globalThis.fetch, timeoutMs = 4000 }) {
  let contactId = '';
  try { contactId = contact?.getContactId?.() || ''; } catch { contactId = ''; }
  let result = { ok: false, reason: '' };
  if (!url) result.reason = 'not-configured';
  else if (!contactId || !agentArn) result.reason = 'missing-ids';
  else {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), timeoutMs);
    try {
      const res = await fetchImpl(url, {
        method: 'POST',
        headers: await getHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({ action: 'decline-reoffer', contactId, connectAgentArn: agentArn }),
        signal: ctrl.signal,
      });
      const body = await res.json().catch(() => ({}));
      result = res.ok && body.ok ? { ...body, ok: true } : { ok: false, reason: body.error || `HTTP ${res.status}` };
    } catch (err) {
      result = { ok: false, reason: err?.name === 'AbortError' ? 'timeout' : (err?.message || 'error') };
    } finally {
      clearTimeout(timer);
    }
  }
  if (!result.ok || !result.dismissed) {
    await new Promise(done => {
      try { contact.clear({ success: done, failure: done }); } catch { done(); }
    });
    result.clearedInBrowser = true;
  }
  return result;
}
